import * as React from 'react'
import { useEffect, useState } from 'react'
import { InputProps, NormalizedSingleFrameProps } from './wrapperTypes'
import { taskCallback } from './request'
import Logan from '@/common/utils/logan'
import { HOME_POP_LOGAN } from './const'
import ErrorBoundary from './ErrorBoundary'
import { reportRaptorMetrics } from '@/common/SLRaptor'

export const translateProps = (Comp: React.ComponentType<NormalizedSingleFrameProps>) => {
  const HOC = () => {
    const inputProps = Mach?.data
    const { data, id: resourceId, ...otherProps } = inputProps
    if (!data) {
      Logan.log({ type: HOME_POP_LOGAN.NO_DATA, data: { data: data } })
      return null
    }

    if (data?.length <= 0) {
      Logan.log({ type: HOME_POP_LOGAN.DATA_LENGTH_EMPTY, data: { data: data } })
      return null
    }
    const { id: campaignId, ...props } = data[0]

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (props.launchTaskShowState) {
        taskCallback({
          channelId: props?.channelId,
          launchTaskId: campaignId,
        })
      }
      try {
        if (Mach.env.osName === 'ios') {
          const curPage = Mach.requireModule('SLCommon')?.curPage?.()
          reportRaptorMetrics({ FFS_SHOW_PAGE: 1 }, { page: `${Mach.env.osName}_${curPage}` })
        } else {
          Mach.requireModule('SLCommon')?.curPage?.(
            {
              type: 'eventOfLogin',
            },
            (result: Record<string, string>) => {
              const curPage = result.content
              reportRaptorMetrics({ FFS_SHOW_PAGE: 1 }, { page: `${Mach.env.osName}_${curPage}` })
            },
          )
        }
      } catch (e) {
        Mach.requireModule('Raptor').reportBusinessException('homepage pop get page error', JSON.stringify(e, Object.getOwnPropertyNames(e)))
      }
      reportRaptorMetrics(
        { MKT_RESOURCE_SHOW: 1 },
        {
          resourceId: String(resourceId),
          campaignId: String(campaignId),
        },
      )
    }, [])

    return (
      <ErrorBoundary
        tags={{
          resourceId: String(resourceId),
          campaignId: String(campaignId),
        }}
      >
        <Comp resource_id={resourceId} {...otherProps} props={props} campaign_id={campaignId} />
      </ErrorBoundary>
    )
  }

  return HOC
}

export default translateProps
